import { useAppointmentCancelNotificationQuery } from "../../../../../../../api/appointments/useAppointmentCancelNotificationQuery";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useCancelNotificationFlow() {
  const { modals, appointment } = useContext();

  const { data: notification, isLoading } =
    useAppointmentCancelNotificationQuery({
      appointmentId: appointment.id,
    });

  const start = ({ charge, isAdditionalProvider } = {}) => {
    if (!notification) {
      return uiNotification.error(
        "Unable to load cancel notification details. Try again later.",
      );
    }
    if (notification.needToShow) {
      modals.cancelNotification.open({
        charge,
        isAdditionalProvider,
      });
    } else {
      modals.confirmCancel.open({ charge, isAdditionalProvider });
    }
  };

  return {
    start,
    isLoading,
  };
}
